import {
  Campaigns,
  ICustomerRewardDataResp,
  ISearchCustomerResp,
  StampedCustomer
} from "./CommonProps";

import { OwnerDetails } from "./modals/OwnerDetails";
// const CryptoJS = require("crypto-js/hmac-sha256");
export class StampedService {
  public isFirstTime: boolean = true;
  public apiKeyPublic: string;
  public apiKeyPrivate: string;
  public storeHash: string;
  private authToken =
    "cHVia2V5LUN2UTBvd0R1ZzIyajRsODdEdTQ5OXA0RXNXM2RWQzprZXktNThoejM0Q040eUlpMWJSUFQ2MHN1RjlMNjNFTjJz";
  public currentCustomerPoints: number = 0;
  public availablePoints: number = 0;
  public referralCode: string = "";
  public referralUrl: string = "";
  public customerId: number | null = null;
  public currentCustomer: StampedCustomer = null as any;
  public earningPoints: Campaigns = {
    coupons: [],
    earnings: [],
    referrals: null as any,
    spendings: [],
    vip_tiers: []
  };
  private baseUrl = "https://stamped.io/api/v2/";
  constructor(apiKeyPublic: string, apiKeyPrivate: string, storeHash: string) {
    this.apiKeyPrivate = apiKeyPrivate;
    this.apiKeyPublic = apiKeyPublic;
    this.storeHash = storeHash;
  }

  public getPoints(customerEmail: string) {
    return new Promise((resolve: (point: number) => void, reject) => {
      this.searchCustomer(customerEmail).then((Res: ISearchCustomerResp) => {
        if (Res.results.length > 0) {
          resolve(Res.results[0].customer.points);
        }
      });
    });
  }

  public getCustomerById(customerId: number | null) {
    let method = "GET";
    let url =
      this.baseUrl + this.storeHash + "/dashboard/customers/" + customerId;
    let requestOptions: any = {
      method: method,
      headers: this.getHeaders()
    };
    return new Promise(
      (resolve: (data: ISearchCustomerResp) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }
  public searchCustomer(customerEmail: string) {
    let method = "GET";
    let url =
      this.baseUrl +
      this.storeHash +
      "/dashboard/customers/?search=" +
      customerEmail;
    let requestOptions: any = {
      method: method,
      headers: this.getHeaders()
    };
    return new Promise(
      (resolve: (data: ISearchCustomerResp) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }

  private createNewCustomer(owner: OwnerDetails) {
    let url = this.baseUrl + this.storeHash + "/dashboard/customers/add";
    let body = {
      email: owner.email,
      firstName: owner.firstName,
      lastName: owner.lastName,
      tags: "",
      dateBirthday: null
    };
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(body)
    };
    return new Promise(
      (resolve: (customer: StampedCustomer) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }
  public getCustomerRewardData(customerId: number, customerEmail: string) {
    let url =
      this.baseUrl +
      "/rewards/init?apiKey=" +
      this.apiKeyPublic +
      "&sId=" +
      this.storeHash;
    let body = {
      customerId: customerId,
      customerEmail: customerEmail,
      authToken: btoa(
        customerId + ":" + customerEmail + ":" + this.apiKeyPrivate
      )
    };
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(body)
    };
    return new Promise(
      (resolve: (customer: ICustomerRewardDataResp) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }

  public addOrUpdateCustomer(owner: OwnerDetails, customerId: number | null) {
    if (customerId) {
      return this.updateCustomer(customerId, owner);
    } else return this.createNewCustomer(owner);
  }
  public subscribeCustomer(customerEmail: string) {
    let url =
      this.baseUrl +
      "/" +
      this.storeHash +
      "/customers/subscribe?email=" +
      customerEmail +
      "&appType=2";
    // let url = this.baseUrl + "/" + this.storeHash + "/survey/subscribe";
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders()
      // body: JSON.stringify({ "emails": [customerEmail] })
    };
    return new Promise(
      (resolve: (customer: ICustomerRewardDataResp) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }
  private updateCustomer(customerId: number, owner: OwnerDetails) {
    let url =
      this.baseUrl +
      "/" +
      this.storeHash +
      "/dashboard/customers/" +
      customerId;
    let body = {
      email: owner.email,
      firstName: owner.firstName,
      lastName: owner.lastName,
      tags: "",
      dateBirthday: null
    };
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(body)
    };
    return new Promise(
      (resolve: (customer: StampedCustomer) => void, reject) => {
        fetch(url, requestOptions)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          });
      }
    );
  }
  // public vipTierAdjustment(customerId: number | null, vipTierId: number) {
  //     let url = +this.baseUrl + this.storeHash + "/dashboard/customers/" + customerId + "/vipTierAdjustment?tierId=" + vipTierId;

  // }
  public pointsAdjustment(
    customerId: number | null,
    points: number,
    reason: string
  ) {
    let url =
      this.baseUrl +
      this.storeHash +
      "/dashboard/customers/" +
      customerId +
      "/pointsAdjustment?points=" +
      points +
      "&reason=" +
      reason;
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders()
      // body: JSON.stringify({})
    };
    return new Promise((resolve: (points: number) => void, reject) => {
      fetch(url, requestOptions).then((resp) => {
        resp.json().then((data) => {
          resolve(data);
        });
      });
    });
  }
  public redeemReward(
    customerId: number | null,
    campaignId: number,
    points: number
  ) {
    let url =
      this.baseUrl +
      this.storeHash +
      "/dashboard/customers/" +
      customerId +
      "/redeemReward?campaignId=" +
      campaignId; //+"&points=" + points;

    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders()
    };
    // requestOptions.headers["Content-Type"]= "application/x-www-form-urlencoded";
    return new Promise(
      (resolve: (customer: ICustomerRewardDataResp) => void, reject) => {
        fetch(url, requestOptions).then((resp) => {
          resp.json().then((data) => {
            resolve(data);
          });
        });
      }
    );
  }
  public redeemRewards(
    customerId: number | null,
    customerEmail: string,
    campaignId: number,
    points: number
  ) {
    //let key = CryptoJS(customerId + customerEmail, this.apiKeyPrivate).toString();
    let body = {
      customerId: customerId,
      customerEmail: customerEmail,
      authToken: btoa(
        customerId + ":" + customerEmail + ":" + this.apiKeyPrivate
      )
    };
    let url =
      this.baseUrl +
      "rewards/redeem?apiKey=" +
      this.apiKeyPublic +
      "&sId=" +
      this.storeHash +
      "&campaignId=" +
      campaignId +
      "&points=" +
      points;
    let requestOptions: any = {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(body)
    };
    return new Promise(
      (resolve: (customer: ICustomerRewardDataResp) => void, reject) => {
        fetch(url, requestOptions).then((resp) => {
          resp.json().then((data) => {
            resolve(data);
          });
        });
      }
    );
  }
  private getHeaders() {
    let headers: any = {
      "Content-Type": "application/json",
      Authorization:
        "Basic " + btoa(this.apiKeyPublic + ":" + this.apiKeyPrivate)
    };
    // if (isAddAuthorization)
    // headers["Authorization"] = "Basic " + btoa(this.apiKeyPublic + ":" + this.apiKeyPrivate);
    // if (!isAddAuthorization)
    // delete headers["Content-Type"];
    return headers;
  }
}
